export default defineI18nConfig(() => ({
	fallbackLocale: 'pl',
	missingWarn: false,
	fallbackWarn: false,
}))
